import { createSlice } from "@reduxjs/toolkit";
import { getLanguageCode } from "../../utilities/helper";
export interface State {
  userName: string;
  language: string;
  clientId: number;
  lastActiveTIme: any;
}
export const defaultLanguageCode = "EN";
const languageCode = getLanguageCode();
const initialState: State = {
  userName: "",
  clientId: 15000,
  language: languageCode || defaultLanguageCode,
  lastActiveTIme: new Date()
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    resetState: () => initialState,
    setUserDetails: (state, action) => {
      state.userName = action.payload.userName;
      state.clientId = action.payload.clientId;
    },
    updateActiveTime: (state, action) => {
      state.lastActiveTIme = new Date();
    },
    updateLanguage: (state, action) => {
      state.language = action.payload;
    }
  }
});

export const { setUserDetails, resetState, updateActiveTime, updateLanguage } =
  userSlice.actions;

export default userSlice.reducer;
